// extracted by css-extract-rspack-plugin
module.exports =  {"sidebar":"SendStudentSidebar-ZrTq__sidebar","sidebar__send-btn-container":"SendStudentSidebar-BNmP__sidebar__send-btn-container"};